let lastClickedAllergensButton = null;
function initAllergensFocusImpr() {
    const allergensButtons = document.querySelectorAll('.js-popover[data-target="#allergens-popover"]');
    const allergensModal = document.getElementById("allergens-modal");
    if (allergensButtons.length === 0 || allergensModal === null) {
        return;
    }
    allergensButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
            lastClickedAllergensButton = event.currentTarget;
        });
    });
    allergensModal.addEventListener("hidden.bs.modal", () => {
        lastClickedAllergensButton === null || lastClickedAllergensButton === void 0 ? void 0 : lastClickedAllergensButton.focus();
    });
}
/**
 * Show More.
 */
export default {
    init: function () {
        initAllergensFocusImpr();
    },
};
